import React, { RefObject } from "react";
import { Button, InformationalModal } from "@leafly-com/frontend-components";

const LABEL_ID = "add-to-bag-menu-type-bag-reset-modal";

const MED_LABELS = Object.freeze({ short: "med", long: "medical" });
const REC_LABELS = Object.freeze({ short: "rec", long: "recreational" });

type MenuTypeBagResetModalProps = {
  medical: boolean;
  onDismissed?: () => void;
  onNewBagClick?: () => void;
  returnFocusRef: RefObject<{}>;
};

export const MenuTypeBagResetModal: React.FC<MenuTypeBagResetModalProps> = ({
  onDismissed = () => {},
  onNewBagClick = () => {},
  medical,
  ...props
}) => {
  const [pendingBagItemMenuTypeLabels, bagMenuTypeLabels] = medical
    ? [MED_LABELS, REC_LABELS]
    : [REC_LABELS, MED_LABELS];

  const newBagCopy = `yes, start a new ${pendingBagItemMenuTypeLabels.short} bag`;
  const keepBagCopy = `no, keep existing ${bagMenuTypeLabels.short} bag`;

  return (
    <InformationalModal
      aria-labelledby={LABEL_ID}
      onDismissed={onDismissed}
      {...props}
    >
      {({ dismiss }: { dismiss: () => void }) => (
        <>
          <div id={LABEL_ID} className="heading--m">
            Switch to a {pendingBagItemMenuTypeLabels.long} bag?
          </div>

          <div className="text-sm mt-lg">
            You’ve previously added goodies from the {bagMenuTypeLabels.long}{" "}
            menu. Clear your cart and start a{" "}
            {pendingBagItemMenuTypeLabels.long} bag?
          </div>

          <Button
            className="button--full mt-xxl"
            onClick={() => {
              onNewBagClick();
              dismiss();
            }}
          >
            {newBagCopy}
          </Button>

          <Button
            className="button--full mt-lg"
            variant="tertiary"
            onClick={dismiss}
          >
            {keepBagCopy}
          </Button>
        </>
      )}
    </InformationalModal>
  );
};
